/* unplugin-vue-components disabled */import script from "./Zszx.vue?vue&type=script&lang=ts&setup=true"
export * from "./Zszx.vue?vue&type=script&lang=ts&setup=true"

import "./Zszx.vue?vue&type=style&index=0&id=19aedc4c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19aedc4c"]])

export default __exports__